var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDistributionImg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.333,
    height: 17.978,
    viewBox: "0 0 29.333 17.978",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M93.956,256.572a2.577,2.577,0,1,0,2.578,2.577A2.577,2.577,0,0,0,93.956,256.572Zm0,3.7a1.12,1.12,0,1,1,1.121-1.12A1.12,1.12,0,0,1,93.956,260.269Z",
    transform: "translate(-84.79 -243.748)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M282.425,256.572A2.577,2.577,0,1,0,285,259.149,2.577,2.577,0,0,0,282.425,256.572Zm0,3.7a1.12,1.12,0,1,1,1.121-1.12A1.12,1.12,0,0,1,282.425,260.269Z",
    transform: "translate(-259.668 -243.748)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.848,133.242a.659.659,0,0,1-.657.657h-9.06a.658.658,0,0,1-.656-.657v-.394a.658.658,0,0,1,.656-.656h9.06a.658.658,0,0,1,.657.656Z",
    transform: "translate(-21.782 -128.337)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.134,87.485c-.945-.246-1.486-.4-1.857-1.117l-1.241-2.512a2.656,2.656,0,0,0-2.142-1.3H63.2a.219.219,0,0,1-.228-.225V80.221a1.361,1.361,0,0,0-1.445-1.485H47.692c-1.408,0-2.076.668-2.076,1.485v1.32a.381.381,0,0,0,.38.393h7.74a1.315,1.315,0,0,1,1.313,1.313v.394a1.315,1.315,0,0,1-1.313,1.313H46a.348.348,0,0,0-.38.379v.454c0,.361.495.361.495.361h5.21a1.315,1.315,0,0,1,1.313,1.313v.394a1.315,1.315,0,0,1-1.313,1.313H46.193s-.577-.011-.577.449v3.191A1.49,1.49,0,0,0,47.1,94.293h.82c.186,0,.213-.1.213-.156a3.359,3.359,0,0,1,6.717,0c0,.052-.015.156.127.156H61.6c.131,0,.126-.111.126-.156a3.359,3.359,0,0,1,6.717,0c0,.052,0,.156.081.156h1.669a1.472,1.472,0,0,0,1.468-1.468V90.037C71.66,87.689,70.919,87.689,70.134,87.485Zm-2.793-.131H63.164a.2.2,0,0,1-.2-.168v-3.48s-.01-.134.212-.134h1.192a2.363,2.363,0,0,1,1.906,1.159l1.1,2.235a1.75,1.75,0,0,0,.149.242C67.572,87.262,67.506,87.355,67.342,87.355Z",
    transform: "translate(-42.327 -78.736)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.651,191.678a.658.658,0,0,1-.656.657H.656A.658.658,0,0,1,0,191.678v-.394a.658.658,0,0,1,.656-.657H8.995a.658.658,0,0,1,.656.657Z",
    transform: "translate(0 -182.559)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDistributionImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/distributionImg.99033a2d.svg";
export { ForwardRef as ReactComponent };